import React from "react";
import {AddToCartModal} from "./AddToCartModal";
import {ModalDeliveryPointAndPurchaseOrderNumber} from "./ModalDeliveryPointAndPurchaseOrderNumber";

export function AddToCartAndDeliveryPointModals({
                                                    addToCartModalOpen, setAddToCartModalOpen,
                                                    navigator, productFeature, deliverySiteFeature
                                                }) {
    function isFeatureReady(feature) {
        return feature && feature.loaded
    }

    return isFeatureReady(productFeature) && isFeatureReady(deliverySiteFeature) && (<>
        <ModalDeliveryPointAndPurchaseOrderNumber
            open={deliverySiteFeature.isDeliveryPointModalOpened}
            feature={deliverySiteFeature}
            handleSetDelivery={(deliveryPointName, deliveryDate, purchaseOrderNumber) => {
                deliverySiteFeature.setDelivery(deliveryPointName, deliveryDate, purchaseOrderNumber).then(() => {
                    setAddToCartModalOpen(true);
                });
            }}
            puntosEntrega={deliverySiteFeature.deliverySites}
            navigator={navigator}
        />
        <AddToCartModal
            open={addToCartModalOpen}
            setOpen={setAddToCartModalOpen}
            handleAddToCart={(quantity) => productFeature.addProductToCart(quantity)}
            product={productFeature.productDetailInformation}/>
    </>)
};
